import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Leg ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row h-screen py-6"
}
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto" }
const _hoisted_8 = { class: "flex flex-row w-3/4" }
const _hoisted_9 = { class: "py-3 w-full" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Leg", -1)
const _hoisted_11 = { class: "flex flex-row w-3/4" }
const _hoisted_12 = { class: "py-3 w-full" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Lokasi Awal", -1)
const _hoisted_14 = { class: "w-3/4 text-12px xxl:text-14px" }
const _hoisted_15 = { class: "py-3 w-full" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Destinasi", -1)
const _hoisted_17 = { class: "flex flex-row w-3/4" }
const _hoisted_18 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Leg Code", -1)
const _hoisted_20 = { class: "py-3 w-1/2" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tipe Leg", -1)
const _hoisted_22 = { class: "border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_23 = { class: "flex flex-row w-3/4" }
const _hoisted_24 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Transport Moda", -1)
const _hoisted_26 = { class: "py-3 w-1/2" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Vendor", -1)
const _hoisted_28 = { class: "flex flex-row w-3/4" }
const _hoisted_29 = { class: "py-3 w-1/2 mr-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, [
  /*#__PURE__*/_createTextVNode(" Estimasi SLA Min. "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-500" }, "(Jam)")
], -1)
const _hoisted_31 = { class: "text-12px text-red-lp-200" }
const _hoisted_32 = { class: "text-12px text-red-lp-200" }
const _hoisted_33 = { class: "py-3 w-1/2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, [
  /*#__PURE__*/_createTextVNode(" Estimasi SLA Max. "),
  /*#__PURE__*/_createVNode("span", { class: "text-gray-500" }, "(Jam)")
], -1)
const _hoisted_35 = { class: "text-12px text-red-lp-200" }
const _hoisted_36 = { class: "text-12px text-red-lp-200" }
const _hoisted_37 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Leg"),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Rute leg yang aktif akan digunakan dalam mapping rute pada Route Management. Jangan khawatir status dapat di aktifkan atau di non-aktifkan kembali kapan saja ")
], -1)
const _hoisted_39 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_41 = { class: "ml-4" }
const _hoisted_42 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_43 = { class: "py-3" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Leg", -1)
const _hoisted_45 = { class: "my-1 text-black-lp-300" }
const _hoisted_46 = { class: "flex" }
const _hoisted_47 = { class: "py-3" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_49 = { class: "my-1 text-black-lp-300" }
const _hoisted_50 = { class: "text-gray-lp-500" }
const _hoisted_51 = { class: "py-3" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_53 = { class: "my-1 text-black-lp-300" }
const _hoisted_54 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "arrowLeft"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _withDirectives(_createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _ctx.onOpenSave,
                class: "px-8 bg-red-lp-300"
              }, null, 8, ["onClick"]), [
                [_vShow, !_ctx.isError]
              ])
            ])
          ]),
          (_ctx.isError || _ctx.isErrorEdit)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.fetchDetailLeg
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode("textarea", {
                        placeholder: _ctx.dataDetail.legName,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.legOrigin,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.legDestination,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.legCode,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode("input", {
                        type: "text",
                        placeholder: _ctx.dataDetail.legType,
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                        disabled: _ctx.isDisabled
                      }, null, 10, ["placeholder", "disabled"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("input", {
                          type: "text",
                          placeholder: _ctx.dataDetail.transport,
                          class: 
                  `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                          disabled: _ctx.isDisabled
                        }, null, 10, ["placeholder", "disabled"])
                      ]),
                      _createVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode("input", {
                          type: "text",
                          placeholder: _ctx.dataDetail.vendorName,
                          class: 
                  `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                ,
                          disabled: _ctx.isDisabled
                        }, null, 10, ["placeholder", "disabled"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          placeholder: "Estimasi Min",
                          maxlength: "5",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataDetail.minSla = $event)),
                          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterInputMin && _ctx.filterInputMin(...args))),
                          class: 
                  `py-1.5 xxl:py-3 px-4 rounded border ${
                    _ctx.validationSlaMin() || _ctx.validationEmptyMin()
                      ? 'border-red-lp-200'
                      : 'border-gray-lp-400'
                  } focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                
                        }, null, 34), [
                          [_vModelText, _ctx.dataDetail.minSla]
                        ]),
                        _withDirectives(_createVNode("span", _hoisted_31, "Estimasi SLA Min. tidak boleh 0", 512), [
                          [_vShow, _ctx.validationSlaMin()]
                        ]),
                        _withDirectives(_createVNode("span", _hoisted_32, "Estimasi SLA Min. tidak boleh kosong", 512), [
                          [_vShow, _ctx.validationEmptyMin()]
                        ])
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          placeholder: "Estimasi Max",
                          maxlength: "5",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataDetail.maxSla = $event)),
                          onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.filterInputMax && _ctx.filterInputMax(...args))),
                          class: 
                  `py-1.5 xxl:py-3 px-4 rounded border ${
                    _ctx.validationSlaMax() || _ctx.validationEmptyMax()
                      ? 'border-red-lp-200'
                      : 'border-gray-lp-400'
                  } focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                
                        }, null, 34), [
                          [_vModelText, _ctx.dataDetail.maxSla]
                        ]),
                        _withDirectives(_createVNode("span", _hoisted_35, "SLA Max. tidak boleh lebih kecil dari SLA Min.", 512), [
                          [_vShow, _ctx.validationSlaMax()]
                        ]),
                        _withDirectives(_createVNode("span", _hoisted_36, "Estimasi SLA Max. tidak boleh kosong", 512), [
                          [_vShow, _ctx.validationEmptyMax()]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("div", _hoisted_39, [
                      _createVNode("div", {
                        onClick: _cache[6] || (_cache[6] = () => _ctx.onOpenRoute()),
                        class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
                      }, [
                        _hoisted_40
                      ], 2),
                      _createVNode("div", _hoisted_41, " Rute Leg " + _toDisplayString(_ctx.isRoute ? "Aktif" : "Tidak Aktif"), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", _hoisted_46, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                        }, _toDisplayString(_ctx.isRoute ? "Active" : "Inactive"), 3)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode("div", _hoisted_49, _toDisplayString(_ctx.createdAt), 1),
                    _createVNode("div", _hoisted_50, _toDisplayString(_ctx.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode("div", _hoisted_53, _toDisplayString(_ctx.updatedAt), 1),
                    _createVNode("div", _hoisted_54, _toDisplayString(_ctx.updatedBy), 1)
                  ])
                ])
              ]))
        ])),
    (_ctx.openRoute)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onClose: _ctx.onCloseRoute,
          onSubmit: _ctx.changeRoute,
          title: 'Non-aktifkan Rute Leg',
          message: 
      'Selama Rute Leg berstatus non-aktif maka Rute Leg tidak dapat digunakan pada Route management'
    ,
          image: "inactive-location",
          textSuccess: 'Non-aktifkan',
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onClose", "onSubmit"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeErrorTransport,
      title: "Leg Tidak Dapat Diaktifkan",
      message: "Status tidak dapat diubah menjadi aktif. Mohon cek status transport & vendor",
      image: "warning",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit"]), [
      [_vShow, _ctx.isErrorTransport]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseModalSuccess,
      title: "Perubahan Disimpan",
      message: `Rute Leg “${_ctx.dataDetail.legName}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openModalSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Rute Leg",
      message: 
      `Anda yakin akan menyimpan perubahan untuk Rute Leg ${_ctx.dataDetail.legName}`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave()]
    ])
  ], 64))
}